export default {
  AMORTIZATION_DEPRECIATION: 1,
  EXCHANGE_RATE_DIFFERENCES: 2,
  ACCOUNTING_INVOICES_KLA: 3,
  SALES_INVOICES_WITHOUT_TEMPLATE: 4,
  TAX_ACCOUNTS: 5,
  SUPPLIERS_AND_CUSTOMERS_ACCOUNTS: 6,
};
